// extracted by mini-css-extract-plugin
export default {"container":"styles_container__P-xA1","container-no-contact":"styles_container-no-contact__tB-M4","loader":"styles_loader__V4W32"};